import styled from '@emotion/styled'
import React from 'react'
import { DEFAULT_THEME_COLORS } from 'css/theme'
import useConfig from 'modules/config/state/use-config'
import { STEP_LAYOUT_SMALL_WIDTH } from '../shared/shared-step-layout.styled'

interface StepButtonProps {
  children: React.ReactNode
  onClick?: () => void
  dataId?: string
  type?: 'button' | 'submit' | 'reset'
  disabled?: boolean
  variant: 'skip' | 'submit'
}

export default function StepButton({
  children,
  onClick,
  dataId,
  type = 'button',
  disabled = false,
  variant,
}: StepButtonProps) {
  const config = useConfig()

  const primaryColor =
    config.theme['--theme-color__brand-primary'] ||
    DEFAULT_THEME_COLORS['--theme-color--neutral-10']

  return (
    <Button
      type={type}
      onClick={onClick}
      data-id={dataId}
      disabled={disabled}
      variant={variant}
      primaryColor={primaryColor}
    >
      {children}
    </Button>
  )
}

const Button = styled.button<{ variant: 'skip' | 'submit'; primaryColor: string }>`
  min-width: 170px;
  height: 48px;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  gap: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 1;

  /* Variant-specific styles */
  ${({ variant, primaryColor }) => {
    if (variant === 'skip') {
      return `
        border: 1px solid ${DEFAULT_THEME_COLORS['--theme-color--neutral-80']};
        background: ${DEFAULT_THEME_COLORS['--theme-color--neutral-100']};
        color: ${DEFAULT_THEME_COLORS['--theme-color--neutral-10']};

        &:hover {
          background: ${DEFAULT_THEME_COLORS['--theme-color--neutral-90']};
        }
      `
    } else {
      return `
        border: 1px solid ${primaryColor};
        background: ${primaryColor};
        color: white;

        &:hover {
          opacity: 0.9;
        }
      `
    }
  }}

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  @media (max-width: ${STEP_LAYOUT_SMALL_WIDTH}) {
    width: 100%;
  }
`
